module.exports = __webpack_public_path__ + "media/images/client/AssistantChat/selection-mobile-6cf3d7482ed0d722f172c876bc0de21c.png";